import { getAxios } from '../../axiosWithToken'

export const getUserMe = () => getAxios().get('users/me/')
export const postResetPassword = email =>
  getAxios().post('users/reset-password/', { email })

export const checkResetPasswordToken = token =>
  getAxios().get(`users/change-password/?token=${token}`)

export const postChangePassword = (token, password) =>
  getAxios().post('users/change-password/', { token, password })



// WEBPACK FOOTER //
// /opt/build/repo/src/api/async/users/index.js